// Session storage wrapper

const PREFIX = '5ugc_';

export const sessionStorageService = {
  /**
   * Get item from sessionStorage
   * @param {string} key
   * @param {*} defaultValue
   * @returns {*}
   */
  get(key, defaultValue = null) {
    try {
      const item = sessionStorage.getItem(PREFIX + key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },

  /**
   * Set item in sessionStorage
   * @param {string} key
   * @param {*} value
   */
  set(key, value) {
    try {
      sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch (error) {
      console.warn('sessionStorage set error:', error);
    }
  },

  /**
   * Remove item from sessionStorage
   * @param {string} key
   */
  remove(key) {
    sessionStorage.removeItem(PREFIX + key);
  },

  /**
   * Clear all 5UGC items from sessionStorage
   */
  clear() {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  },
};
